function animateLines(elems) {
	$.each(elems, function () {
		const $this = $(this);
		const dataBy = $this.data('lineBy');
		const options = {};
		options[dataBy] = $this.data('lineNum');

		$this.velocity(options, 400);
	});
}

function addLink(element, url, target) {
	element
		.on('click', function () {
			window.open(url, target);
		});
}

function animateSvgText(item, color) {
	item.velocity({
		fill: color,
	}, {
		loop: true,
		duration: 1000
	});
}

$(window).on('svgRendered', (event, $elem) => {
	if ($elem.attr('id') === 'business-model_svg') {
		const $bmsvgItem = $('#business-model_svg').find('[data-link]');

		$bmsvgItem.each(function () {
			const $this = $(this);
			const bmsvgLink = $this.attr('data-link');
			const target = $this.data('linkOuter') ? '_blank' : '_self';

			addLink($this, bmsvgLink, target);
		});

		$('.text-pulse--blue').each(function () {
			animateSvgText($(this), '#005a9d');
		});

		$('.text-pulse--light-blue').each(function () {
			animateSvgText($(this), '#7f9ece');
		});

		$('.business-model__svg').removeClass('preloader');

		$.Velocity($elem.find('.stone-stroke'), 'fadeIn', 700)
			.then(() => {
				$elem.find('.stone-fill').velocity('fadeIn', 400, 'ease');
				return null;
			})
			.delay(300)
			.then(() => {
				$elem.find('.stone-circle').velocity('fadeIn', 400, 'ease');
				return null;
			})
			.delay(400)
			.then(() => {
				animateLines($elem.find('.stone-line-horizontal'));
				return null;
			})
			.delay(400)
			.then(() => {
				animateLines($elem.find('.stone-line-vertical'));
				$elem.find('.stone-indicator').velocity('fadeIn', 400, 'ease');
				return null;
			})
			.catch(err => console.error(err));

		$elem.find('.stone-diagram-elem').on('click', function () {
			const $this = $(this);
			const data = $this.data('elemDiagram');

			if ($this.hasClass('is-active')) {
				$(`[data-elem-line="${data}"]`).removeClass('is-active');
				$this.removeClass('is-active');
			} else {
				$(`[data-elem-line="${data}"]`).addClass('is-active');
				$this.addClass('is-active');
			}
		});

		$('.legend-item').on('click', function () {
			const $this = $(this);
			const legendDataName = $this.data('legend');

			if ($this.hasClass('is-active')) {
				$this
					.removeClass('is-active');
				$(`[data-${legendDataName}]`).removeClass('is-active');
			} else {
				$this
					.addClass('is-active');
				$(`[data-${legendDataName}]`).addClass('is-active');
			}
		});
	}
});

$('.js-fade-in.check-viewport').on('show', function () {
	const $this = $(this);

	if ($this.hasClass('visible')) {
		$this
			.removeClass('check-viewport visible')
			.velocity('fadeIn', 800, 'ease-in');
	}
});



// WEBPACK FOOTER //
// ./temp/components/business-model/index.js